import {Component, Input, OnChanges, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';


@Component({
    selector: 'app-checkbox-group',
    templateUrl: './checkbox-group.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CheckboxGroupComponent extends CustomFormControl implements OnChanges {
    @Input() items: any[] = [];
    @Input() bindBy: string;
    @Input() bindLabel: string;
    @Input() bindValue: string;
    public size = undefined;
    public mappedItems = undefined;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items) {
            this.mapItems();
        }
        if (!Array.isArray(this.control.value)) {
            this.control.setValue([]);
        }
    }

    mapItems() {
        this.mappedItems = Array.isArray(this.items)
            ? this.items.map(item => ({
                label: this.bindLabel ? item[this.bindLabel] : item,
                value: this.bindValue ? item[this.bindValue] : item
            }))
            : [];
    }

    checked(itemValue) {
        if (!Array.isArray(this.control.value)) {
            return false;
        }
        if (this.bindBy) {
            return this.bindValue
                ? !!this.control.value.find(item => item[this.bindBy] === itemValue)
                : !!this.control.value.find(item => item[this.bindBy] === itemValue[this.bindBy]);
        }
        return this.control.value.includes(itemValue);
    }

    onChange(event) {
        this.control.setValue(event);
    }
}
